import { Connection, Pool } from "snowflake-sdk";

import { Environment, Logger } from "@abacus/common";

export interface AccountContract {
  accountId: number;
  contractId: number;
  createdAt: Date;
  createdBy: string;
  id: number;
  isCalcPrimary: boolean;
  lastModified: Date;
  lastModifiedBy: string;
}

export interface AccountId {
  id: number;
}

export interface ContractId {
  id: number;
}

export interface AccountPaymentEntityId {
  accountId: number;
  paymentEntityId: number;
}

export interface AdjustmentType {
  id: number;
  name: string;
  oaCategoryName: string;
}

export interface ContractTerm {
  attachments: string[];
  contractId: number;
  id: number;
  type: ContractTermType;
}

export enum ContractTermType {
  Contribution = "contribution",
  ContributionSchedule = "contribution_schedule",
  ContributorSchedule = "contributor_schedule",
  Label = "label",
  Product = "product",
  Track = "track",
}

export interface SnowflakeClientOptions {
  database: string;
  environment: Environment;
  logger?: Logger;
  pool: Pool<Connection>;
}

export interface SnowflakeConfig {
  account: string;
  authenticator: string;
  database: string;
  environment: Environment;
  host?: string;
  privateKey?: string;
  privateKeyPath?: string;
  privateKeyPass?: string;
  role?: string;
  username?: string;
  warehouse?: string;
}

export interface StatementPeriod {
  closedBy: string;
  closedDate: Date;
  id: number;
  month: number;
  name: string;
  status: StatementPeriodStatus;
  year: number;
}

export interface StatementPeriodId {
  id: number;
}

export enum StatementPeriodStatus {
  Closed = "closed",
  Current = "current",
  Open = "open",
}

export interface Upc {
  displayUpc: string;
  upc: number;
}

export interface UpcVendor {
  displayUpc: string;
  upc: number;
  vendorId: number;
}
